import * as Redux from 'redux'
import * as ReduxObservable from 'redux-observable'
import * as App from '../../app'
import * as Request from '../../request'
import { ApplicationState } from '../../rootReducer'
import * as Router from '../../router'
import * as Actions from './actions'
import * as Utils from './utils'

export const createStatusUpdateEpic = (event: string, updateAction: Actions.UpdateStatusAction) =>
  (
    action$: ReduxObservable.ActionsObservable<Redux.Action>,
    store: Redux.Store<ApplicationState>,
  ) =>
    action$.ofType(Utils.updateStatusConstant(event))
    .map((action: Actions.StateChangeActionObject) =>
      updateAction(store.getState().app.selectedCommunity, action.change))

export const createFilterChangeEpic =
  (event: string, filterAction: Actions.FilteredFetcher, filterSelector: Actions.FilterSelector) =>
  (
    action$: ReduxObservable.ActionsObservable<Redux.Action>,
    store: Redux.Store<ApplicationState>,
  ) =>
    action$.ofType(Utils.filterStatusConstant(event))
    .map(() => filterAction(store.getState().app.selectedCommunity, filterSelector(store.getState())))

export const createDateChangeEpic =
  (event: string, loadAction: Actions.DateFetcher, filterSelector: Actions.DateSelector) =>
  (
    action$: ReduxObservable.ActionsObservable<Redux.Action>,
    store: Redux.Store<ApplicationState>,
  ) =>
    action$.ofType(event)
    .map(() => loadAction(store.getState().app.selectedCommunity, filterSelector(store.getState())))

export const createFilterAddedEpic =
  (event: string, loadAction: Actions.FilteredFetcher, filterSelector: Actions.FilterSelector) =>
  (
    action$: ReduxObservable.ActionsObservable<Redux.Action>,
    store: Redux.Store<ApplicationState>,
  ) =>
    action$.ofType(Request.successConstant(event))
    .map(() => loadAction(store.getState().app.selectedCommunity, filterSelector(store.getState())))

export const createInitialLoadEpic =
  (url: string, loadAction: Actions.FilteredFetcher, filterSelector: Actions.FilterSelector) =>
  (
    action$: ReduxObservable.ActionsObservable<Redux.Action>,
    store: Redux.Store<ApplicationState>,
    {history}: App.Dependencies,
  ) => action$.ofType(App.SELECT_COMMUNITY)
    .map(() => loadAction(store.getState().app.selectedCommunity, filterSelector(store.getState())))

export const createNavigateToPageEpic =
  (url: string, loadAction: Actions.FilteredFetcher, filterSelector: Actions.FilterSelector) =>
  (
    action$: ReduxObservable.ActionsObservable<Redux.Action>,
    store: Redux.Store<ApplicationState>,
    {history}: App.Dependencies,
  ) => action$.ofType(Router.ON_ENTER)
    .filter(() => history.location.pathname.includes(url))
    .map(() => loadAction(store.getState().app.selectedCommunity, filterSelector(store.getState())))



// WEBPACK FOOTER //
// ./src/components/is_active/epic.ts